import React from "react";
import { statusMeta } from "@/lib/status";

export default function StatusPill({ status, className = "" }) {
  const m = statusMeta(status);
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-bold ${className}`}
      style={{ background: m.badgeBg, color: m.badgeText }}
      data-testid={`status-pill-${status}`}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ background: m.dot }} />
      {m.label}
    </span>
  );
}
